import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["binary-grid", {
      compact: $props.compact
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.grid, (row, rowIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: `row_${rowIndex}`,
      class: "binary-row"
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, colIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: `cell_${rowIndex}_${colIndex}`,
        class: _normalizeClass(["binary-cell", {
          filled: cell === 1
        }])
      }, null, 2);
    }), 128))]);
  }), 128))], 2);
}